import React, { lazy, Suspense } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Layout from "../layouts/Main";
import { reportsRoutes } from "@/features/reports/routes/reportsRoute";
import ProtectedRoute from "@/guards/ProtectedRoute";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";
import { candidateRoutes } from "@/features/candidatesManagment/routes/CandidatesManagmentRoute";
import { jobRequisitionRoutes } from "@/features/jobRequisition/route/jobRequisitionRoute";
import { jobRequestsRoutes } from "@/features/jobRequests/route/jobRequestsRoute";
import { companyRegistrationRoute } from "@/features/companyRegistration/routes/companyRegistrationRoute";
import { positionsRoutes } from "@/features/positionsManagment/routes/positionsManagmentRoute";
import { settingsRoute } from "@/routes/SettingsRoute";
import Dashboard from "@/features/dashboard/pages/Dashboard";
import { clientsBoardRoutes } from "@/features/clientsBoard/routes/clientsBoardRoute";
import { branchesRoutes } from "@/features/branches/routes/branchesRoute";
import { interviewVersionsRoute } from "@/features/interviewVersions/routes/interviewVersionsRoute";
import { companyProfileRoutes } from "@/features/company/companyProfile/routes/companyProfileRoute";
import { offersRoutes } from "@/features/offers/routes/offersRoute";
import { evaluationFormsListRoutes } from "@/features/evaluationForms/routes/evaluationFormsRoute";
import { assessmentsRoutes } from "@/features/assessments/routes/assessmentsRoute";

const MainLayout = () => {
  return (
    <ProtectedRoute>
      <Layout>
        <Suspense fallback={<LoadingFeedback />}>
          <Outlet />
        </Suspense>
      </Layout>
    </ProtectedRoute>
  );
};

export const mainRoutes = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      
      
      // ==== Dashboard Routes ====
      ...candidateRoutes,
      ...reportsRoutes,
      ...jobRequisitionRoutes,
      ...jobRequestsRoutes,
      ...companyRegistrationRoute,
      ...clientsBoardRoutes,
      ...branchesRoutes,
      ...positionsRoutes,
      ...settingsRoute,
      ...interviewVersionsRoute,
      ...companyProfileRoutes,
      ...offersRoutes,
      ...evaluationFormsListRoutes,
      ...assessmentsRoutes,
    ],
  },
];
